import React from "react";
import { HStack } from '~/native-ui';

export class VariadicRangeField extends React.Component {
    onChange (valueKey, value,)  {
        this.props.onChange?.({ ...this.props.value, [valueKey]: value });
    }

    renderInput(prop, placeholder, title) {
        const { Component, isRange, value, filterType, ...props } = this.props;

        return React.createElement(Component, {
            ...props,
            placeholder,
            title,
            tooltip: null,
            value: value[prop],
            onChange: (value) => this.onChange(prop, value)
        })
    }

    render () {
        const { filterType, trans, ...props } = this.props;


        switch(filterType) {
            case "before":
                return this.renderInput("max", trans('to'), props.title)
            case "after":
                return this.renderInput("min", trans('from'), props.title)
            default:
                return (
                    <HStack space={4}>
                        <HStack flex="1">
                            { this.renderInput("min", trans('from'), props.title) }
                        </HStack>
                        <HStack flex="1">
                            { this.renderInput("max", trans('to'), props.title && " ") }
                        </HStack>
                    </HStack>
                )
        }
    }
}


export const WithVariadicRangeField = (Component) => (props) => <VariadicRangeField { ...props } Component={Component} />